import { render, staticRenderFns } from "./VerificationDialog.vue?vue&type=template&id=e9f321e4&scoped=true&"
import script from "./VerificationDialog.vue?vue&type=script&lang=js&"
export * from "./VerificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./VerificationDialog.vue?vue&type=style&index=0&id=e9f321e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f321e4",
  null
  
)

export default component.exports